import type { ReactNode } from 'react';
import { NavLink } from 'react-router-dom';
import type { MeView } from '@skolveckan/shared';
import {
  IconCalendar,
  IconChecklist,
  IconClock,
  IconSliders,
  IconUser,
  IconWeek,
} from './Icons';

interface Props {
  me: MeView | null;
  aside?: ReactNode;
  children: ReactNode;
}

const NAV = [
  { to: '/', label: 'Idag', icon: <IconClock />, end: true },
  { to: '/vecka', label: 'Vecka', icon: <IconWeek />, end: false },
  { to: '/uppgifter', label: 'Uppgifter', icon: <IconChecklist />, end: false },
];

export function AppShell({ me, aside, children }: Props) {
  const isTeacher = me?.memberships.some((m) => m.role === 'teacher') ?? false;
  const className = me?.memberships[0]?.className;

  return (
    <div className="shell">
      <nav className="sidebar" aria-label="Huvudmeny">
        <div className="sidebar__brand">
          <span className="sidebar__mark" aria-hidden="true">
            <IconCalendar size={16} />
          </span>
          <span className="sidebar__name">Skolveckan</span>
        </div>

        <div className="sidebar__nav">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                isActive ? 'sidebar__link sidebar__link--active' : 'sidebar__link'
              }
            >
              {item.icon}
              {item.label}
            </NavLink>
          ))}
          {isTeacher && (
            <NavLink
              to="/admin"
              className={({ isActive }) =>
                isActive ? 'sidebar__link sidebar__link--active' : 'sidebar__link'
              }
            >
              <IconSliders />
              Admin
            </NavLink>
          )}
        </div>

        <div className="sidebar__divider" />
        {aside}
        <div className="grow" />

        <div className="sidebar__user">
          <span className="sidebar__avatar" aria-hidden="true">
            <IconUser />
          </span>
          <span className="stack">
            <span className="sidebar__username">{me?.user.name ?? '…'}</span>
            <span className="sidebar__usermeta">
              {className ? `Klass ${className}` : 'Ingen klass'}
            </span>
          </span>
        </div>
      </nav>

      <main className="content">{children}</main>
    </div>
  );
}
